import React, { useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/*
 * /a/:asset_id   —   QR scan entry point.
 *   • If not logged in: redirect to /login with ?redirect=/assets/<id>
 *   • If logged in:    redirect to /assets/<id>
 *   The actual authorisation decision (full vs minimal card) is made server-side
 *   when the asset detail page fetches the asset.
 */
export default function AssetScanPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(`/assets/${id}`, { replace: true });
    } else {
      // Preserve destination for post-login redirect
      const dest = encodeURIComponent(`/assets/${id}`);
      navigate(`/login?redirect=${dest}`, { replace: true });
    }
  }, [id, user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-ink-2">
      Opening asset …
    </div>
  );
}
